import { useBlockProps, InspectorControls } from "@wordpress/block-editor";
import { ToggleControl } from "@wordpress/components";
import { PanelBody } from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import ProcessesList from "./ProcessesList";
import { StrictMode } from "react";

/**
 * Edit component for the Processes List block.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.attributes - The block attributes.
 * @param {Function} props.setAttributes - The function to update block attributes.
 * @returns {JSX.Element} The rendered edit component.
 */

export default function Edit({ attributes, setAttributes }) {
    const { isStriped } = attributes;
    const blockProps = useBlockProps({
        className: `wp-block-table pagination-table processes-list 
        ${isStriped ? "is-style-stripes" : ""} `,
    });

    return (
        <figure
            id="processes-list"
            {...blockProps}
        >
            <InspectorControls>
                <PanelBody title={__("Filters", "cpcv-plugin")}>
                    <ToggleControl
                        label={__("Striped table", "cpcv-plugin")}
                        checked={isStriped}
                        onChange={(value) =>
                            setAttributes({ isStriped: value })
                        }
                    />
                </PanelBody>
            </InspectorControls>

            <ProcessesList />
        </figure>
    );
}
